import React from 'react';
import { getAllMenuItems as getPagesConfig, getIconElement } from '@config/pages';
import { useAuth } from '@contexts/AuthContext';

type Permission = keyof import('../contexts/AuthContext').IUser['permissions'];

export interface MenuItem {
  label: string;
  path: string;
  icon: React.ReactElement;
  /** Um array exige QUALQUER UMA das permissões (OR) — ver PageConfig.permission. */
  permission?: Permission | Permission[] | undefined;
  /** Ver PageConfig.scope (config/pages.tsx) — usado por App.tsx para agrupar o dropdown do menu
   * em "Do condomínio" / "Geral". */
  scope: 'client' | 'global';
}

// Export for compatibility
export const getAllMenuItems = (): MenuItem[] => {
  const pagesConfig = getPagesConfig();
  return pagesConfig.map((page) => ({
    label: page.label,
    path: page.path,
    icon: getIconElement(page.iconName),
    permission: page.permission,
    scope: page.scope
  }));
};

// Hook personalizado para obter itens do menu filtrados
export const useMenuItems = () => {
  const { hasPermission } = useAuth();
  
  const allMenuItems = getAllMenuItems();
  
  // Filtrar itens baseado nas permissões do usuário — array = OR (qualquer uma delas basta).
  return allMenuItems.filter((item) => {
    if (!item.permission) return true;
    return Array.isArray(item.permission)
      ? item.permission.some((p) => hasPermission(p))
      : hasPermission(item.permission);
  });
};
